import { useState, useEffect } from 'react';

// Define the valid encounter types from the database enum
type EncounterType = 'InPerson' | 'TeleHealth' | 'RemoteTheropyMonitoring' | 'SMS_Survey';

type AppointmentType = {
  value: string;
  label: string;
};

// Format the enum values into user-friendly labels
const formatEncounterType = (type: EncounterType): string => {
  const labels: Record<EncounterType, string> = {
    InPerson: 'In-Person Visit',
    TeleHealth: 'Telehealth',
    RemoteTheropyMonitoring: 'Behavioral Health Integration Services',
    SMS_Survey: 'SMS Survey'
  };
  return labels[type] || type;
};

export function useAppointmentTypes() {
  const [appointmentTypes, setAppointmentTypes] = useState<AppointmentType[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const loadAppointmentTypes = () => {
      try {
        setIsLoading(true);
        
        // Define the known enum values from the database
        const encounterTypes: EncounterType[] = [
          'InPerson',
          'TeleHealth',
          'RemoteTheropyMonitoring',
          'SMS_Survey'
        ];

        // Map to the required format with formatted labels
        const types = encounterTypes.map(type => ({
          value: type,
          label: formatEncounterType(type)
        }));

        setAppointmentTypes(types);
      } catch (err) {
        console.error('Error initializing appointment types:', err);
        setError(err as Error);
      } finally {
        setIsLoading(false);
      }
    };

    loadAppointmentTypes();
  }, []);

  return { appointmentTypes, isLoading, error };
}



